import bayern from '../src/img/bayern.png'
import dc from '../src/img/dc.png'
import openlibrary from '../src/img/openlibrary.png'
import fifa22 from '../src/img/fifa22.png'
import nz from '../src/img/nz.png'
import bcci from '../src/img/bcci.png'
export const hobbies = [
    {
      id: 1,
      img: bayern,
      link: "https://fcbayern.com/en",
    },
    {
      id: 2,
      img: dc,
      link: "https://www.delhicapitals.in/",
    },
    {
      id: 3,
      img: bcci,
      link: "https://www.bcci.tv/",
    },
    {
      id: 4,
      img: openlibrary,
      link: "https://openlibrary.org/",
    },
    {
      id: 5,
      img: nz,
      link: "https://www.tourismnewzealand.com/",
    },
    {
      id: 6,
      img: fifa22,
      link: "https://www.ea.com/games/fifa/fifa-22/buy",
    },
  ];